export default "__VITE_ASSET__B2Rp$nD8__"